import IMG1 from '../../../assets/img/certificates/certificates14001.png';
import IMG2 from '../../../assets/img/certificates/RINA.jpg';
import IMG3 from '../../../assets/img/certificates/certificates45001.png';
import IMG4 from '../../../assets/img/certificates/SOA_rilascio.jpg';
import IMG5 from '../../../assets/img/certificates/politica_qualita.jpg';

import IS09001 from '../../../assets/document/9001_2015.pdf';
import IS014001 from '../../../assets/document/14001_2015.pdf';
import IS045001 from '../../../assets/document/45001_2018.pdf';
import soa2025 from '../../../assets/certificates/34854_FINCANTIERI_SI_SPA.pdf';
import saluteSicurezza from '../../../assets/document/Politica_Qualita_Ambiente_Sicurezza.pdf';
import unipdr125 from '../../../assets/document/UNIPDR_125.pdf';
import antic from '../../../assets/certificates/ALLEGATO 1 - POLITICA_ANTICORRUZIONE_ISO_37001-rev 1.pdf';
import ax from '../../../assets/certificates/FCSI - ISO 37001_2016 Cert. nr.  IT345302 exp. 26.08.2028 IT.pdf';
import az from '../../../assets/certificates/FCSI - ISO 37001_2016 Cert. nr.  IT345302 exp. 26.08.2028 EN.pdf';

export const nameCertificates = [
  {
    image: IMG1,
    title: 'UNI EN ISO 37001:2016_POLITICA ANTICORRUZIONE',
    url: antic,
  },
  {
    image: IMG1,
    title: 'UNI EN ISO 37001:2016_EN',
    url: az,
  },
  {
    image: IMG1,
    title: 'UNI EN ISO 37001:2016_IT',
    url: ax,
  },
  {
    image: IMG1,
    title: 'UNI EN ISO 14001:2015',
    url: IS014001,
  },
  {
    image: IMG2,
    title: 'UNI EN ISO 9001:2015',
    url: IS09001,
  },
  {
    image: IMG3,
    title: 'UNI EN ISO 45001:2018',
    url: IS045001,
  },
  {
    image: IMG4,
    title: 'SOA OG9 CLASS. V – OG10 CLASS. VIII – OG11 CLASS. VIII',
    url: soa2025,
  },
  {
    image: IMG5,
    title: 'POLITICA SALUTE E SICUREZZA SUL LAVORO, AMBIENTE ED ENERGIA',
    url: saluteSicurezza,
  },
  {
    image: IMG5,
    title: 'UNIPDR 125',
    url: unipdr125,
  },
];
